// extracted by mini-css-extract-plugin
export default {"docusignTabContainer":"tab_docusignTabContainer__IgaRp","dataPanelContainer":"tab_dataPanelContainer__0GLW-"};